import type { GameDescriptor } from '../game-registry.js';
import { ScratchScene } from '../scenes/ScratchScene.js';

export const scratchDescriptor: GameDescriptor = { code: 'scratch', scene: ScratchScene, supportsAuto: true };
